import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-color-block" }


import { Button } from 'ant-design-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TextColorButton',
  props: {
  color: {
    type: String,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Button), { class: "text-color-btn" }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "text-color-block-content",
          style: _normalizeStyle({ backgroundColor: __props.color })
        }, null, 4)
      ])
    ]),
    _: 3
  }))
}
}

})